import React, { useEffect, useState } from "react";
import UserPanelTitle from "../UserPanelTitle/UserPanelTitle";
import "./RecentArticles.css";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import { Link } from "react-router-dom";
import ImageNotFound from "../../Assets/images/ImageNotFound.jpg";

export default function RecentArticles() {
    const [blog, setBlog] = useState([]);
    useEffect(() => {
        axiosConfig
            .get("api/blog?page=1&pageSize=4&orderBy=RegisterDate")
            .then((result) => {
                setBlog(result.data.data);
            });
    }, []);
    return (
        <div className="product-category-sideBar">
            <div className="product-category-sideBar-list">
                <UserPanelTitle title="مقالات اخیر سنیک" />
                {blog != null &&
                    blog.map((item) => (
                        <Link to={"/article/" + item.title} key={item.id}>
                            <div className="product-category-sideBar-item">
                                {item.image != null ? (
                                    <img
                                        src={
                                            axiosConfig.defaults.baseURL +
                                            "Images/BlogImage/" +
                                            item.id +
                                            "/" +
                                            item.image
                                        }
                                        alt={item.title}
                                    />
                                ) : (
                                    <img src={ImageNotFound} alt={item.title} />
                                )}
                                <div className="product-category-sideBar-info">
                                    <h1>{item.title}</h1>
                                    <span>
                                        {new Date(
                                            item.registerDate
                                        ).toLocaleDateString("fa-IR")}
                                    </span>
                                </div>
                            </div>
                        </Link>
                    ))}
            </div>
        </div>
    );
}
